import React, { Component } from 'react'
import io from '../../utils/socket-client';
import Modal from 'react-modal';
import JqxDropDownList from '../../widgets/jqwidgets-react/react_jqxdropdownlist';
import GroupGrid from './GroupGrid';
import GroupGridFilterCustomerContainer from "./GroupGridFilterCustomerContainer";

export default class GroupGridContainer extends Component {

    constructor(props){
        super(props);
        this.state = {
            modalIsOpen: false,
            userLogin: null,
            modalPassValidation: false
        };
        this.groupNameOptions = [];
        if(props.groupNameList.length) {
            props.groupNameList.forEach((item, index) => {
                this.groupNameOptions.push(<option key={index} value={item}>{item}</option>);
            });
        }
    }

    componentDidMount(){
        this.grid = this.refs.grid.refs.grid;;
        this.gridData = this.refs.grid.source.localdata;
    }

    openNewGroupModal() {
        setTimeout(() => {
            this.refs.groupName.value = this.props.groupNameList[0];
            this.onChangeGroup(null, this.props.groupNameList[0]);
        }, 0);

        this.setState({
            modalIsOpen: true,
            userLogin: null,
            modalPassValidation: false
        });
    }

    closeModal() {
        this.props.clearError();
        this.setState({modalIsOpen: false});
    }

    addGroup(event){
        let newGroup = {
            login: this.state.userLogin,
            groupName: this.refs.groupName.value
        };
        io.sendChange({
            uri:io.GROUP_URI,
            operation: io.OPERATION_CREATE,
            data: newGroup,
            success: () => {
                newGroup.userName = this.state.userName;
                this.grid.addrow(null, newGroup);
                this.gridData.push(newGroup);
                this.props.updateGroup(newGroup.login, newGroup.groupName);
                this.closeModal();
            },
            fail: () => this.closeModal()
        });

        event.preventDefault();
    }

    onChangeGroup(event, val){
        let value = val || event.target.value;
        let promoterList = [];
        if(this.props.users) {
            this.props.users.forEach((item) => {
                if (item.type === 'promoter') {
                    promoterList.push(item)
                }
            });
        }

        this.gridData.forEach((item) => {
            if(item.groupName === value){
                promoterList = promoterList.filter((userItem) => {
                    return userItem.login !== item.login
                });

            }
        });
        let userList = [];
        if(promoterList.length) {
            promoterList.forEach((item) => {
                let label = item.userName + ' (' + item.login + ')';
                userList.push({label: label, login: item.login, userName: item.userName});
            });
        }

        function sort(a, b){
            let aName = a.userName, bName = b.userName;
            if(aName < bName) return -1
            else if(aName > bName) return 1
            else if(aName === bName) return 0;
        }

        userList.sort(sort);

        this.refs.userList.source(userList);
        this.refs.userList.clearSelection();
        this.refs.userList.on('change', this.changeDropDownValue.bind(this));

        this.setState({
            userList: userList,
        });
    }

    changeDropDownValue(event){
        let login = event.args.item.originalItem.login;
        let userName = event.args.item.originalItem.userName;
        if(login){
            this.setState({userLogin: login, userName, modalPassValidation: true});
        }
    }

    filter(groupName){
        let filtergroup = new window.$.jqx.filter();
        let filter_or_operator = 1;
        let filtervalue = groupName;
        let filtercondition = 'contains';
        let filter1 = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
        filtergroup.addfilter(filter_or_operator, filter1);
        this.grid.addfilter('groupName', filtergroup);
        this.grid.applyfilters();
        this.grid.hidecolumn('groupName');
    }

    clearFilter(){
        this.grid.clearfilters(false);
        this.grid.showcolumn('groupName');
    }

    render() {
        const customStyles = {
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)'
            },
            overlay: {
                zIndex: 100,
            }
        };

        return (
            <div style={{display: 'flex', width: '100%', height: '100%', flexDirection: 'row', overflow: 'hidden'}}>
                <GroupGridFilterCustomerContainer ref={'filterContainer'} onFilter={this.filter.bind(this)} clearFilter={this.clearFilter.bind(this)} items={this.props.groupNameList}/>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal.bind(this)}
                    style={customStyles}
                    ariaHideApp={false}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Добавить группу">

                    <form style={{display: 'flex', flexDirection: 'column'}} onSubmit={this.addGroup.bind(this)} method="post">
                        <select style={{marginBottom: 10, fontSize: 16}} ref={"groupName"} onChange={this.onChangeGroup.bind(this)} required>
                            {this.groupNameOptions}
                        </select>
                        <JqxDropDownList
                            style={{marginBottom: 10, fontSize: 16}}
                            ref={"userList"}
                            width={250}
                            filterable={true}
                            placeHolder={'Пользователь'}
                            filterPlaceHolder={'Поиск'}>
                        </JqxDropDownList>

                        <div style={{marginTop: 10, display: 'flex', justifyContent: 'space-between'}}>
                            <button style={{width: '45%', marginRight: 10, fontSize: 17}} disabled={!this.state.modalPassValidation}>Готово</button>
                            <button style={{width: '45%', fontSize: 17}} onClick={this.closeModal.bind(this)}>Отмена</button>
                        </div>
                    </form>
                </Modal>
            <GroupGrid
                ref={'grid'}
                groups={this.props.groups}
                groupNameList={this.props.groupNameList}
                users={this.props.users}
                openNewGroupModal={this.openNewGroupModal.bind(this)}
                updateGroup={this.props.updateGroup}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/GroupGridContainer.js